import type { TroubleData, TroubleType } from '@erp/shared-types';

export function hasActiveTrouble(
  troubleData: TroubleData | null | undefined,
  type?: TroubleType | string,
): boolean {
  if (!troubleData) return false;
  return troubleData.some((e) => e.active && (!type || e.type === type));
}

export function hasActiveTroubleValue(
  troubleData: TroubleData | null | undefined,
  value: string,
): boolean {
  if (!troubleData) return false;
  return troubleData.some((e) => e.active && e.value === value);
}

export function getActiveTroubleEntries(
  troubleData: TroubleData | null | undefined,
) {
  if (!troubleData) return [];
  return troubleData.filter((e) => e.active);
}
